export default {
  schema: {
    type: "string",
  },
  uiSchema: {
    "ui:widget": "textarea",
    row: 1,
  },
};
